import React, { useState, useEffect } from "react";
import { DayCampPageOptions } from "../Constants/RegistrationPageOptions";
import EventCardList from "./EventCardList";
import '../Styles/DayCampWeekSelection.scss';

function DayCampWeekSelection({ pageOptions, setSelectedPage, selectedPage, eventRegistrationType, setWeekSelection }) {

   const [queriedEvents, setQueriedEvents] = useState()
   const [nextPage, setNextPage] = useState()
   const selectedEvents = ['Day Camp', 'Deaf Day Camp']

   const getEvents = async () => {

      try {
         const response = await fetch('/getevents', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ selectedEvents })
         })

         const campEvents = await response.json();
         setQueriedEvents(campEvents.data);
         console.log("here are the events", campEvents.data)

         setNextPage(DayCampPageOptions.PesonalInfo)


      } catch (error) {
         console.log(error)
      }
   }

   useEffect(() => {
      getEvents()
   }, []);

   return (
         <div className="dayCampWeekSelectionContent">
               <div className="dayCampWeekSelectionHeading">
                  Select Your Week
               </div>
               <div className="eventCardList">
                  <EventCardList eventRegistrationType={eventRegistrationType}
                     campEvents={queriedEvents}
                     nextPage={nextPage}
                     setWeekSelection={setWeekSelection}
                     setSelectedPage={setSelectedPage} />
               </div>
         </div>
   )

}
export default DayCampWeekSelection;